import { ErrorMessage } from '@/components/Message/ErrorMessage';
import { ChangeEvent, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface SwitchProps extends React.PropsWithRef<
  JSX.IntrinsicElements['input']
> {
  leftText?: string | React.ReactNode;
  rightText?: string | React.ReactNode;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  errorMessage?: string;
  containerClassName?: string;
  switchClassName?: string;
  triggerClassName?: string;
  leftTextClassName?: string;
  rightTextClassName?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  (
    {
      leftText,
      rightText,
      value = '',
      checked = false,
      disabled,
      errorMessage,
      containerClassName,
      switchClassName,
      triggerClassName,
      leftTextClassName,
      rightTextClassName,
      onChange,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={twMerge(
          'flex flex-col gap-0.75',
          containerClassName,
          disabled && 'hover:cursor-not-allowed',
        )}
      >
        <label
          className={twMerge(
            'switch items-start',
            triggerClassName,
            disabled && 'pointer-events-none',
          )}
        >
          {leftText && (
            <span
              className={twMerge(
                'text-sm',
                leftTextClassName,
                disabled && 'opacity-50',
              )}
            >
              {leftText}
            </span>
          )}
          <input
            ref={ref}
            name="check"
            disabled={disabled}
            checked={checked}
            type="checkbox"
            value={value}
            className={twMerge(
              '-mt-0.5',
              checked && 'bg-primary',
              switchClassName,
            )}
            onChange={onChange}
            {...rest}
          />
          {rightText && (
            <span
              className={twMerge(
                'text-sm',
                rightTextClassName,
                disabled && 'opacity-50',
              )}
            >
              {rightText}
            </span>
          )}
        </label>
        {errorMessage && <ErrorMessage message={errorMessage} />}
      </div>
    );
  },
);
